import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import api from "@/lib/api";
import TraceMap from "../bottle/TraceMap";
import TraceTimeline from "../bottle/TraceTimeline";
import { TraceSummary } from "../bottle/Traceability";

export default function TraceabilityModal({ code, onClose }) {
  const [events, setEvents] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api.get(`/admin/codes/${code.id}/traceability`)
      .then((r) => !cancelled && setEvents(r.data))
      .catch(() => !cancelled && setEvents([]));
    return () => { cancelled = true; };
  }, [code.id]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ background: "rgba(0,0,0,0.75)" }} data-testid="trace-modal" onClick={onClose}>
      <div className="glass rounded-2xl p-8 max-w-5xl w-full fade-up max-h-[90vh] flex flex-col" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-6">
          <div>
            <p className="overline text-[var(--vault-text-muted)]">Traceability</p>
            <h3 className="font-display text-2xl mt-1">{code.label || code.code}</h3>
            <p className="text-sm text-[var(--vault-text-muted)] mt-1 font-mono-vault">{code.code}</p>
          </div>
          <button onClick={onClose} className="p-1 rounded hover:bg-white/5" data-testid="trace-modal-close">
            <X className="w-5 h-5" />
          </button>
        </div>
        {events === null && <p className="py-10 text-center text-[var(--vault-text-muted)]">Loading…</p>}
        {events && events.length === 0 && (
          <p className="py-12 text-center text-[var(--vault-text-muted)]" data-testid="trace-modal-empty">No NFC/QR scans recorded yet.</p>
        )}
        {events && events.length > 0 && (
          <div className="flex-1 overflow-auto">
            <TraceSummary events={events} />
            <div className="h-80 rounded-xl overflow-hidden border mb-6" style={{ borderColor: "var(--vault-border)" }}>
              <TraceMap events={events} testId="trace-modal-map" />
            </div>
            <TraceTimeline events={events} showIp />
          </div>
        )}
      </div>
    </div>
  );
}
